module.exports = __webpack_public_path__ + "img/sv2.bd226ef3.svg";